<template>
    <div>
        <v-layout row wrap :align-center="!wideLayout" :justify-center="!wideLayout" :fill-height="!wideLayout">
            <v-flex xs12 sm12 :md12="wideLayout" :lg12="wideLayout" :md10="!wideLayout" :lg10="!wideLayout" :xl8="!wideLayout">
                

                <v-data-table
                :headers="headers"
                :items="items"
                :options.sync="options"
                :server-items-length="totalItems"
                :loading="loading"
                class="elevation-1"
                :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'mdi-page-first',
                lastIcon: 'mdi-page-last',
                prevIcon: 'mdi-chevron-left',
                nextIcon: 'mdi-chevron-right',
                itemsPerPageOptions: [5,10,15,25,50, 100]
                }"
                >
                <template v-slot:top>
                    <v-toolbar class="elevation-1" color="white">
                        <v-toolbar-title class="font-weight-regular body-1">{{ settings.title}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-flex xs4 md4 lg4 v-show="breakPoint">
                            <!--<v-text-field class="pt-4"  label="Išči..." @keyup.esc="search = ''" v-model="search" append-icon="mdi-magnify" single-line></v-text-field>-->
                            <v-text-field class="pt-4"  label="Išči..." @keyup.esc="search = ''" @keyup="doSearch()" v-model="search" append-icon="mdi-magnify" single-line clearable @click:clear="doSearch()"></v-text-field>
                        </v-flex>
                        <v-divider
                        class="mx-4"
                        inset
                        vertical
                        ></v-divider>
                        <v-tooltip v-if="btnRefresh" top>
                            <template v-slot:activator="{ on }">
                                <v-btn @click="refreshDataTable" class="toolbar_btn_fab" elevation="0" color="secondary" v-on="on" fab x-small dark>
                                    <v-icon>mdi-sync</v-icon>
                                </v-btn>
                            </template>
                            <span>Osveži podatke</span>
                        </v-tooltip>
                        <v-tooltip v-if="btnToggleColumns" top>
                            <template v-slot:activator="{ on }">
                                <v-btn @click="toggleColumns()" class="toolbar_btn_fab" elevation="0" color="secondary" v-on="on" fab x-small dark>
                                    <v-icon>mdi-dots-horizontal</v-icon>
                                </v-btn>
                            </template>
                            <span>Filtriraj stolpce</span>
                        </v-tooltip>
                    </v-toolbar>
                    <br>
                </template>
                <template v-slot:item.action="{ item }">
                    <!--
                    <v-tooltip top v-if="(item.user_id == null || item.user_id == '') && (entranceDevices().includes(item.device_id) )">
                        <template v-slot:activator="{ on }">
                            <v-icon
                                id="dt_btn_edit"
                                color="pink darken-1"
                                small
                                class="mr-2"
                                @click="addRegistrationNumberItem(item)"
                                v-on="on"
                            >
                                mdi-plus-circle
                            </v-icon>
                        </template>
                        <span>Validiraj registrsko številko</span>
                    </v-tooltip>
                    -->
                    <!--<v-tooltip top v-if="(item.user_uuid == null || item.user_uuid == '')  && createUserPermission() && item.registration_plate_number">
                        <template v-slot:activator="{ on }">
                            <v-icon
                                id="dt_btn_edit"
                                color="indigo"
                                small
                                class="mr-2"
                                @click="addItem(item)"
                                v-on="on"
                            >
                                mdi-account-plus
                            </v-icon>
                        </template>
                        <span>Dodaj uporabnika</span>
                    </v-tooltip>
                    -->
                    <v-tooltip top v-if="item.user_uuid != null && item.user_uuid != ''">
                        <template v-slot:activator="{ on }">
                            <!--<v-icon
                                id="dt_btn_edit"
                                color="success"
                                small
                                class="mr-2"
                                @click="editItem(item)"
                                v-on="on"
                            >
                                mdi-account-edit
                            </v-icon>-->
                            <a :href="editItemUrl(item)" style="text-decoration:none;">
                                <v-icon
                                id="dt_btn_edit"
                                color="success"
                                small
                                class="mr-2"
                                v-on="on"
                                >
                                
                                mdi-account-edit
                                </v-icon>
                            </a>
                            
                        </template>
                        <span>Uredi uporabnika</span>
                    </v-tooltip>
                    <!--<v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-icon
                                id="dt_btn_delete"
                                color="error"
                                small
                                @click="deleteItem(item)"
                                v-on="on"
                            >
                                mdi-delete
                            </v-icon>
                        </template>
                        <span>Izbriši</span>
                    </v-tooltip>-->
                </template>
                <template v-slot:item.device_name="{ item }">
                    <v-chip label class="" v-if="item.device_name !== null && item.device_name !=='null' && item.device_name !== ''" :color="getDeviceColor(item.device_id)" dark small>{{ item.device_name }}</v-chip>
                    <span v-else>{{ item.device_name }}</span>
                </template>
                <template v-slot:item.event_name="{ item }">
                    <v-chip label class="" v-if="item.event_id !== null && item.event_id !=='null' && item.event_id !== ''" :color="getEventColor(item.event_id)" dark small>{{ item.event_name }}</v-chip>
                    <span v-else>{{ item.event_name }}</span>
                </template>
                <template v-slot:progress>
                    <v-progress-linear absolute  indeterminate :height="progressHeight()"></v-progress-linear>
                </template>
                <template slot="no-data">
                    <div class="no_data" v-show="!searchQuery">{{ (this.loading) ? "Obdelava podatkov je v teku ..." : "Ni podatkov za prikaz." }}</div>
                    <div class="no_data" v-show="searchQuery">{{ (this.loading) ? 'Obdelava podatkov za iskani niz "'  + this.search + '" je v teku ...' :  `Ni podatkov za iskani niz »${this.search}«.`}}</div>
                </template>
                <template slot="loading">
                    <div class="no_data">Obdelava podatkov je v teku ...</div>
                </template>
                </v-data-table>
            </v-flex>

            <v-dialog v-model="dialog" persistent max-width="490">
                <v-card>
                    <v-card-title></v-card-title>
                    <v-card-text>
                        <v-icon text>mdi-delete</v-icon>
                        {{ dialog_text }}
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text color="error" @click.native="dialogCancel()">Prekliči</v-btn>
                        <v-btn text :loading="loading" color="success" @click.native="dialogConfirm()">Nadaljuj</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

        <add-user-dialog></add-user-dialog>
        <add-registration-number-dialog></add-registration-number-dialog>
    </div>
</template>

<script>
import { post, get, put, destroy, API_ENDPOINT, DEMO_API_ENDPOINT } from '@/helpers/api'
import { EventBus } from '@/main.js'
import AddUserDialog from '@/components/AddUserDialog.vue'
import AddRegistrationNumberDialog from '@/components/AddRegistrationNumberDialog.vue'
import { getUserApplicationRole, getUserApplicationPermissions, checkPermissions } from '@/helpers/utilities'

export default {
    props: ['settings', 'queryParameters', 'boxedLayout'],
    name: 'dashboard-data-table',

    components: {
        AddUserDialog,
        AddRegistrationNumberDialog
    },

    data: () => ({
        search: '',
        totalItems: 0,
        items: [],
        loading: true,
        options: {},
        rowsPerPageItems: [5,10,15,25,50,100, -1], 
        interval: null,
        dialog: false,
        dialog_text: '',
        itemToDelete: null,
        searchTimer: null
    }),

    watch: {
        options: {
            handler (value) {
            this.getDataFromApi()
                .then(data => {
                   this.items = data.items
                   this.totalItems = data.totalItems
               })
               .catch(error => {
                   this.items = [];
                   this.totalItems = 0;
                   window.console.log(error)
               })

                //window.console.log(this.options)
                //window.console.log(this.params)
                //window.console.log("Options:")
                //window.console.log(value)

                let itemsPerPage = value.itemsPerPage

                //window.console.log("Items per page: ", itemsPerPage)
                this.$store.commit("APP_SETTING", {
                    setting: "dt_events",
                    key: "items_per_page",
                    value: itemsPerPage
                })

            },
            deep: true,
        },

        /*search(newValue) {
            this.$store.commit('SET_SEARCH', newValue)
            this.getDataFromApi()
                .then(data => {
                   this.items = data.items
                   this.totalItems = data.totalItems
               })
               .catch(error => {
                   this.items = [];
                   this.totalItems = 0;
                   window.console.log(error)
               })
        },*/

        searchFromStore(newValue) {
            this.search = newValue
            this.doSearch()
        }

        /*items(newValue) {
            window.console.log(this.items)
        }*/
    },

    computed: {
        params(nv) {
            return {
                ...this.options,
                query: this.search
            }
        },

        searchQuery() {
           return (this.search != null && this.search.trim() != '') ? true : false;
       },

       btnRefresh() {
           if(this.settings && this.settings.toolbar && this.settings.toolbar.buttons && this.settings.toolbar.buttons.refresh) {
               return true
           }

           return false
       },

       btnExport() {
           if(this.settings && this.settings.toolbar && this.settings.toolbar.buttons && this.settings.toolbar.buttons.export) {
               return true
           }

           return false
       },

       btnAddNew() {
           if(this.settings && this.settings.toolbar && this.settings.toolbar.buttons && this.settings.toolbar.buttons.addNew) {
               return true
           }

           return false
       },

       btnToggleColumns() {
           if(this.settings && this.settings.toolbar && this.settings.toolbar.buttons && this.settings.toolbar.buttons.toggleColumns && 
                this.settings.eventBus && this.settings.eventBus.toggleColumnsId != null && this.settings.eventBus.toggleColumnsId.trim() != ''
           ) {
               return true
           }

           return false
       },

       breakPoint() {
           if(this.$vuetify.breakpoint.mdAndUp) {
                return true;
            }

             return false;
       },

       apiParams() {
           let params = {
                ...this.options,
                query: this.search,
                columns: this.settings.headers.map(header => {
                    return header.value
                })
            }

            if(this.queryParameters && this.queryParameters != null) {
                let queryParams = this.queryParameters
                params = {
                    ...params,
                    ...queryParams
                }
            }

            //window.console.log("queryParams")
            //window.console.log(params)

           return params;
       },

       headers() {
           return this.settings.headers.filter(header => {
               if(header.visibility) {
                   return header
               }
           });
       },

       wideLayout() {
           if(this.boxedLayout !== undefined) {
               if(this.boxedLayout === true) {
                   return false
               }

               return true
           }

           return true
       },

       searchFromStore: {
           get() {
               return this.$store.getters.search
           },

           set(value) {
               this.$store.commit('SET_SEARCH', this.search)
           }
       }
    },

    methods: {
        checkApplicationPermissions(requiredPermissions) {
            return checkPermissions(requiredPermissions, getUserApplicationPermissions())
        },

        createUserPermission() {
            return checkPermissions([], getUserApplicationPermissions())
        },

        editUserPermission() {
           return checkPermissions([], getUserApplicationPermissions()) 
        },

        goToFirstPage() {
            this.$set(this.options, 'page', 1)
        },

        getDataFromApi () {
            this.loading = true
            
            if(Object.prototype.hasOwnProperty.call(this.settings, 'eventBus') && Object.prototype.hasOwnProperty.call(this.settings.eventBus, 'totalItems')) {
                if(this.settings.eventBus.totalItems) {
                    EventBus.$emit(this.settings.eventBus.totalItems.event, {progress: true, value: 0})
                }
            }

            if(Object.prototype.hasOwnProperty.call(this.settings, 'eventBus') && Object.prototype.hasOwnProperty.call(this.settings.eventBus, 'sumItems')) {
                if(this.settings.eventBus.sumItems) {
                    EventBus.$emit(this.settings.eventBus.sumItems.event, {progress: true, queryParameters: this.apiParams})
                }
            }

            return new Promise((resolve, reject) => {
                //post(API_ENDPOINT + this.settings.endpoint, this.apiParams)
                post(API_ENDPOINT + this.settings.endpoint, this.apiParams)            
                .then(response => {
                    //window.console.log("API data")
                    //window.console.log(response)
                    const {
                       sortBy,
                       sortDesc, 
                       page,
                       itemsPerPage 
                    } = this.options;

                    //this.pagination.rowsPerPage = response.data.meta.per_page
                    //console.log(response)
                    const items = response.data.data
                    const totalItems = response.data.meta.total

                    if(Object.prototype.hasOwnProperty.call(this.settings, 'eventBus') && Object.prototype.hasOwnProperty.call(this.settings.eventBus, 'totalItems') ) {
                        if(this.settings.eventBus.totalItems) {
                            EventBus.$emit(this.settings.eventBus.totalItems.event, {value: totalItems})
                        }
                    }

                    resolve({items, totalItems})
                })
                .catch(error => {
                    if(Object.prototype.hasOwnProperty.call(this.settings, 'eventBus') && Object.prototype.hasOwnProperty.call(this.settings.eventBus, 'totalItems')) {
                        if(this.settings.eventBus.totalItems) {
                            EventBus.$emit(this.settings.eventBus.totalItems.event, {value: 0})
                        }
                    }
                    reject(error)
                })
                .finally(() => {
                    this.loading = false
                    if(Object.prototype.hasOwnProperty.call(this.settings, 'eventBus') && Object.prototype.hasOwnProperty.call(this.settings.eventBus, 'totalItems')) {
                        if(this.settings.eventBus.totalItems) {
                            EventBus.$emit(this.settings.eventBus.totalItems.event, {progress: false})
                        }
                    }
                })
            })
      },

      addRegistrationNumberItem(item) {
          EventBus.$emit('ADD_REGISTRATION_NUMBER_DIALOG', item)
      },

      addItem(item) {
          //window.console.log(item)
          EventBus.$emit('ADD_USER_DIALOG', item);
      },

      editItem(item) {
           //window.console.log(item)
           this.$router.push({
                name: 'edit_user',
                params: {
                    id: item.user_uuid
                }
            })

       },

       editItemUrl(item) {
           let itemLocation = ""
           let location = this.$router.resolve({name: 'edit_user', params: {id: item.user_uuid }})
           itemLocation = window.location.origin + location.href;

           return itemLocation

       },

       deleteItem(item) {
           this.itemToDelete = item
           //console.log(item)
            if(Object.prototype.hasOwnProperty.call(this.settings, 'deleteItem')  && this.settings.deleteItem != null) {
                this.dialog_text = this.settings.deleteItem.confirmationText.replace('{str_to_replace}', this.itemToDelete[this.settings.deleteItem.replaceStrWithColumnValue])
            }
            else {
                this.dialog_text = 'Ste prepričani da želite odstraniti zapis' + this.itemToDelete.id + '?'
            }
           this.dialog = true

           //console.log(this.itemToDelete)
       },

       dialogConfirm() {
           new Promise( (resolve, reject) => {
               this.loading = true
               if(this.settings.deleteItem.vuexAction != '' && this.settings.deleteItem.vuexAction != null) {
                   //this.$store.dispatch(this.settings.deleteItem.vuexAction, this.itemToDelete.id)
                   this.$store.dispatch(this.settings.deleteItem.vuexAction, this.itemToDelete[this.settings.editItem.routeParameterValue])
                    .then(response => {
                        this.dialog = false
                        this.loading = false    
                        this.$store.state.snackbar.mode = ''
                        this.$store.state.snackbar.display = true
                        this.$store.state.snackbar.text = this.settings.deleteItem.dialogConfirmSuccessText.replace('{str_to_replace}', this.itemToDelete[this.settings.deleteItem.replaceStrWithColumnValue])

                        this.itemToDelete = null
                        this.refreshDataTable()

                    })
                    .catch(error => {
                        //window.console.log(error)
                        this.dialog = false
                        this.loading = false    
                        this.$store.state.snackbar.mode = 'multi-line'
                        this.$store.state.snackbar.display = true
                        this.$store.state.snackbar.text = this.settings.deleteItem.dialogConfirmFailText.replace('{str_to_replace}', this.itemToDelete[this.settings.deleteItem.replaceStrWithColumnValue])
                        this.itemToDelete = null
                    })
               } else {
                    this.dialog = false
                    this.loading = false    
                    this.$store.state.snackbar.mode = 'multi-line'
                    this.$store.state.snackbar.display = true
                    this.$store.state.snackbar.text = this.settings.deleteItem.dialogConfirmFailText.replace('{str_to_replace}', this.itemToDelete[this.settings.deleteItem.replaceStrWithColumnValue])
                    this.itemToDelete = null
               }
           })
        },

       dialogCancel() {
            this.dialog_confirm = false
            this.dialog = false
            this.itemToDelete = null
       },

       addNewItem() {
           if(this.settings.toolbar.buttons.addNewRoute != '' && this.settings.toolbar.buttons.addNewRoute != null) {
               this.$router.push({name: this.settings.toolbar.buttons.addNewRoute})
           }
       },

       refreshDataTable() {
            this.goToFirstPage();
           this.getDataFromApi()
                .then(data => {
                   this.items = data.items
                   this.totalItems = data.totalItems
               })
               .catch(error => {
                   this.items = [];
                   this.totalItems = 0;
                   window.console.log(error)
               })
       },

       toggleColumns() {
           if(this.settings && this.settings.toolbar && this.settings.toolbar.buttons && this.settings.toolbar.buttons.toggleColumns && 
                this.settings.eventBus && this.settings.eventBus.toggleColumnsId != null && this.settings.eventBus.toggleColumnsId.trim() != '') {
                    EventBus.$emit(this.settings.eventBus.toggleColumnsId, {
                        toggleColumnsMenu: true
                    });
            }
       },

       toggleDataTableColumns(data) {
           if(Object.prototype.hasOwnProperty.call(data, 'dataTableHeaders') ) {
               //window.console.log(data)
                for(var i=0; i<this.settings.headers.length; i++) {
                    var headerFound = false;
                    for(var k=0; k<data.dataTableHeaders.length; k++) {
                        if(this.settings.headers[i].value == data.dataTableHeaders[k]) {
                            this.settings.headers[i].visibility = true
                            headerFound = true
                        }
                    }

                    if(headerFound == false) {
                        //console.log(this.dataTableSettings.headers[i])
                        this.settings.headers[i].visibility = false
                    }
                }

           }
       },

       progressHeight() {
           if(Object.prototype.hasOwnProperty.call(this.settings, 'progressHeight')  && this.settings.progressHeight != null && this.settings.progressHeight != '') {
               return this.settings.progressHeight
           }

           return 3
       },

       getDeviceColor(deviceId) {
           //window.console.log(device_name)
           if(deviceId == 252) {
               return 'blue-grey darken-1'
           }

           if(deviceId == 253) {
               return 'brown-darken-1'
           }

           if(deviceId == 223) {
               return '#5E35B1'
           }

           if(deviceId == 224) {
               return 'blue-darken-1'
           }

           return 'teal darken-1'
       },

       getEventColor(event) {
           //window.console.log(event)
           if(event == 1 || event == 2 || event == 3 || event == 14 || event == 24 || event == 28) {
               return 'green'
           }

           if(event == 8 || event == 38 || event == 39 ) {
               return 'orange'
           }

           if(event == 62 || event == 63 || event == 66 ||event == 67) {
                return '#1E88E5'
           }

           return 'red'
       },

       doSearch() {
           let vm = this
           vm.goToFirstPage();
           if(this.searchTimer) {
               clearTimeout(this.searchTimer)
               this.searchTimer = null
           }

           this.searchTimer = setTimeout(() => {
               vm.getDataFromApi()
                .then(data => {
                   vm.items = data.items
                   vm.totalItems = data.totalItems
               })
               .catch(error => {
                   vm.items = [];
                   vm.totalItems = 0;
                   window.console.log(error)
               })
           }, 600)
       },

       entranceDevices() {
           let entrance_devices = process.env.VUE_APP_DATA_ENTRANCE_DEVICES;
           return entrance_devices.split(",").map(item => {
               return parseInt(item)
           })
       },

       exitDevices() {
           let exit_devices = process.env.VUE_APP_DATA_EXIT_DEVICES;
           return exit_devices.split(",").map(item => {
               return parseInt(item)
           })
       }
    },

    created() {
        /*window.console.log("DataTableSettings");
        window.console.log(this.settings)

        window.console.log("Query Parameters")
        window.console.log(this.queryParameters)*/
    },

    mounted() {
        if(this.settings && this.settings.sortColumn) {
            this.options.sortBy = this.settings.sortColumn
        }

        if(this.settings && this.settings.sortDirection && this.settings.sortDirection == 'desc') {
            this.options.sortDesc = this.settings.sortDirection
        }

        if(Object.prototype.hasOwnProperty.call(this.settings, 'eventBus') ) {
            if(this.settings.eventBus.refreshDataTable != null && this.settings.eventBus.refreshDataTable.trim() != '' ) {
                EventBus.$on(this.settings.eventBus.refreshDataTable, (data) => {
                    this.refreshDataTable()
                })
            }

            if(this.settings.eventBus.search != null && this.settings.eventBus.search.trim() != '') {
                EventBus.$on(this.settings.eventBus.search, (data) => {
                    this.search = data
                })
            }

            if(this.settings.id != null && this.settings.id !== undefined) {
                EventBus.$on(this.settings.id, (data) => {
                    this.toggleDataTableColumns(data)
                })
            }
        }

        if(this.settings && this.settings.updateInterval) {
            this.interval = setInterval(() => {
                if(this.loading != true) {
                    this.getDataFromApi()
                    .then(data => {
                        this.items = data.items
                        this.totalItems = data.totalItems
                    })
                    .catch(error => {
                        this.items = [];
                        this.totalItems = 0;
                        window.console.log(error)
                    })
                }
            }, process.env.VUE_APP_DATA_TABLES_REFRESH_INTERVAL || 180000)
       }

       if(this.settings && this.settings.rowsPerPage) {
           this.options.itemsPerPage = this.settings.rowsPerPage
       }

       //window.console.log("Boxed Layout: " + this.boxedLayout)
       //window.console.log(this.items)
    },

    beforeDestroy() {
        clearTimeout(this.searchTimer)
    },

    destroyed() {
        clearInterval(this.interval)
        if(this.settings && this.settings.eventBus  && this.settings.eventBus.refreshDataTable) {
            if(this.settings.eventBus.refreshDataTable != null && this.settings.eventBus.refreshDataTable.trim() != '' ) {
                EventBus.$off(this.settings.eventBus.refreshDataTable)
            }
        }
        
        EventBus.$off(this.settings.id)
    }
}

</script>

<style scoped>
    .no_data {
        text-align:center !important;
    }

    #style-11::-webkit-scrollbar {
        width: 10px;
        background-color: #F5F5F5;
    }
    
    #style-11::-webkit-scrollbar-track {
        border-radius: 10px;
        background: rgba(0,0,0,0.1);
        border: 1px solid #ccc;
    }

    #style-11::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: linear-gradient(left, #fff, #e4e4e4);
        border: 1px solid #aaa;
    }

    #style-11::-webkit-scrollbar-thumb:hover {
        background: #fff;
    }

    #style-11::-webkit-scrollbar-thumb:active {
        background: linear-gradient(left, #22ADD4, #1E98BA);
    }

    .toolbar_btn_fab {
        margin-right:10px;
    }

    #dt_btn_edit {
        font-size:18px !important;
    }

    #dt_btn_delete {
        font-size:18px !important;
    }

    .no_data {
        color: #000 !important;
    }

    .v-card__text {
        color: rgba(0,0,0,0.90) !important;
    }


</style>